import React, { useEffect, useRef, useState } from "react";
import { Spinner } from '../utils/Spinner';
import { useSpinner } from "../../../hooks/useSpinner";
import Draggable from "react-draggable";

export const Modal = ({
    isOpen,
    closeModal,
    action,
    children,
    title,
    isLargeSize = false,
    textButtons = { confirm: 'Guardar', denied: 'Cancelar' },
    validButton = { confirm: true, denied: true }
}) => {
    const nodeRef = useRef(null);
    const [spinner, mostrarSpinner, ocultarSpinner] = useSpinner();
    const [esExpandido, setEsExpandido] = useState(false);
    const [isDragging, setIsDragging] = useState(false); // Nuevo estado para controlar el lag

    const ajustarTamanioModal = () => setEsExpandido(!esExpandido);

    useEffect(() => {
        !isOpen && setEsExpandido(false);
    },[isOpen])

    return (
        <div
            className={`fixed inset-0 z-[1050] w-full h-full bg-black/60 transition-opacity duration-300
                ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'}
            `}
        >
            <Draggable
                nodeRef={nodeRef}
                handle=".divMovibleCabecera"
                bounds="parent"
                disabled={esExpandido}
                position={esExpandido ? { x: 0, y: 0 } : undefined}
                // Desactivamos transiciones mientras arrastramos
                onStart={() => setIsDragging(true)}
                onStop={() => setIsDragging(false)}
            >
                <div
                    ref={nodeRef}
                    style={{
                        top: esExpandido ? '0' : isLargeSize ? '15%' : '20%',
                        bottom: esExpandido ? '0' : isLargeSize ? '10%' : '20%',
                        left: esExpandido ? '0' : isLargeSize ? '10%': '30%',
                        right: esExpandido ? '0' : isLargeSize ? '10%': '30%',
                        width: esExpandido ? '100%' : isLargeSize ? '80%' : 'auto',
                        height: esExpandido ? '100%' : isLargeSize ? '75%' : 'auto',
                        minHeight: '60%',
                        minWidth: '40%',
                        position: 'absolute',
                        // Importante: No usar transform en el estilo base si Draggable lo usa
                        willChange: isDragging ? 'transform' : 'auto'
                    }}
                    className={`
                        flex flex-col bg-[#2d2f30] rounded-lg shadow-2xl
                        ${isOpen ? 'scale-100' : 'scale-95'}
                        ${isDragging ? '' : 'transition-all duration-300 ease-in-out'}
                    `}
                >
                    {/* CABECERA */}
                    <div className="divMovibleCabecera bg-[#003478] flex items-center justify-between p-3 border-b border-[#4e4e4e] rounded-t-lg cursor-grab active:cursor-grabbing">
                        <h3 className="text-lg font-semibold text-white truncate mr-4 select-none">
                            {title}
                        </h3>
                        <div className="flex gap-2 shrink-0">
                            <button className="p-2 hover:bg-white/10 rounded text-white" onTouchStart={ajustarTamanioModal} onClick={ajustarTamanioModal}>
                                <i className={`fas ${esExpandido ? "fa-window-restore" : "fa-expand"}`}></i>
                            </button>
                            <button className="p-2 hover:bg-red-500 rounded text-white" onTouchStart={closeModal} onClick={closeModal}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    </div>

                    {/* CUERPO */}
                    <div className="relative p-4 flex-auto bg-[#2f3134] overflow-y-auto text-gray-200">
                        {children}
                    </div>

                    {/* FOOTER */}
                    {(validButton.confirm || validButton.denied) && (
                        <div className="bg-[#2d2f30] flex items-center justify-end p-4 gap-3 border-t border-[#4e4e4e] rounded-b-lg">
                            {
                                validButton.confirm ?
                                    <button
                                        className="min-w-[100px] bg-blue-500 hover:bg-blue-600 text-white active:bg-blue-600
                                        font-bold capitalize text-sm px-4 py-2 rounded shadow hover:shadow-lg outline-none
                                        focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-xs"
                                        onClick={async ()=>{
                                            mostrarSpinner();
                                            await action();
                                            ocultarSpinner();    
                                        }}
                                    >
                                        {
                                            spinner 
                                            ? <Spinner></Spinner>
                                            : <span>{textButtons.confirm}</span>
                                        }
                                    </button>
                                : ''
                            }
                            {
                                validButton.denied ?
                                    <button
                                        className=" min-w-[100px] text-white-500 hover:bg-stone-600 rounded background-transparent font-bold capitalize px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-xs"
                                        type="button"
                                        onClick={closeModal}
                                    >
                                        {textButtons.denied} 
                                    </button>
                                : ''
                            }
                        </div>
                    )}
                </div>
            </Draggable>
        </div>
    );
};